/* Portsea: aantal-knop (- 1 +) in de sticky add to cart, alleen zichtbaar op desktop zoals bij Port Douglas */
(function(){
  function init(){
    var s=document.querySelector('sticky-atc');
    if(!s||s.dataset.psQty)return;
    var ctr=s.querySelector('.sticky-atc__controls'), btn=s.querySelector('.sticky-atc__button');
    if(!ctr||!btn)return;
    s.dataset.psQty='1';
    var box=document.createElement('div');
    box.className='ps-sticky-qty';
    box.innerHTML='<button type="button" class="ps-sticky-qty__btn" data-d="-1" aria-label="Decrease quantity">-</button><span class="ps-sticky-qty__num" aria-live="polite">1</span><button type="button" class="ps-sticky-qty__btn" data-d="1" aria-label="Increase quantity">+</button>';
    ctr.insertBefore(box,btn);
    var num=box.querySelector('.ps-sticky-qty__num'), q=1;
    box.addEventListener('click',function(e){
      var b=e.target.closest('[data-d]'); if(!b)return;
      q=Math.max(1,Math.min(99,q+Number(b.dataset.d))); num.textContent=q;
    });
    btn.addEventListener('click',function(){
      if(!box.offsetWidth)return;
      var f=document.querySelector('.product-single__meta form[action*="/cart/add"]')||document.querySelector('form[action*="/cart/add"]');
      if(!f)return;
      var i=f.querySelector('input[name="quantity"][data-ps-sticky]');
      if(q<2&&!i)return;
      if(!i){i=document.createElement('input');i.type='hidden';i.name='quantity';i.setAttribute('data-ps-sticky','1');f.appendChild(i);}
      i.value=q;
      setTimeout(function(){ if(i&&i.parentNode)i.parentNode.removeChild(i); q=1; num.textContent='1'; },4000);
    },true);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  setTimeout(init,800);
})();